import { render, staticRenderFns } from "./AppIndicator.vue?vue&type=template&id=882c8bfa&lang=pug&"
import script from "./AppIndicator.vue?vue&type=script&lang=js&"
export * from "./AppIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports